import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate"

import User from './modules/User'
const store = createStore({
  modules: {
    User: User,
  },
  plugins: [createPersistedState()],
});
export default store;

